import { serverTimestamp } from 'firebase/firestore';

export interface GsgoProfileFormData {
  displayName: string;
  contactEmail: string;
  contactPhone: string;
  relationshipToCkd: string;
  supportInterests: string;
  profileNotes: string;
}

export interface GsgoProfileDefaults {
  displayName?: string;
  contactEmail?: string | null;
}

export const emptyGsgoProfileForm: GsgoProfileFormData = {
  displayName: '',
  contactEmail: '',
  contactPhone: '',
  relationshipToCkd: '',
  supportInterests: '',
  profileNotes: '',
};

function toStringValue(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function mapFirestoreProfileToForm(
  data: Record<string, unknown> | undefined,
  defaults: GsgoProfileDefaults = {}
): GsgoProfileFormData {
  const source = data ?? {};
  const displayName = toStringValue(source.displayName) || defaults.displayName || '';
  const contactEmail = toStringValue(source.contactEmail) || defaults.contactEmail || '';

  return {
    displayName,
    contactEmail,
    contactPhone: toStringValue(source.contactPhone),
    relationshipToCkd: toStringValue(source.relationshipToCkd),
    supportInterests: toStringValue(source.supportInterests) || toStringValue(source.capabilitiesSummary),
    profileNotes: toStringValue(source.profileNotes) || toStringValue(source.pastPerformanceNotes),
  };
}

export function buildProfileFirestorePayload(
  form: GsgoProfileFormData,
  existingPhotoUrl: unknown
): Record<string, unknown> {
  return {
    displayName: form.displayName.trim(),
    contactEmail: form.contactEmail.trim() || null,
    contactPhone: form.contactPhone.trim() || null,
    relationshipToCkd: form.relationshipToCkd.trim() || null,
    supportInterests: form.supportInterests.trim() || null,
    profileNotes: form.profileNotes.trim() || null,
    photoUrl: existingPhotoUrl ?? null,
    updatedAt: serverTimestamp(),
  };
}
